export default "__VITE_ASSET__DH3qJX$W__"